export const htmlQuestions = [
  {
    question: "What is full-form of HTML?",
    options: [
      { answerOption: "Hyper Text Markup Language", isCorrect: true },
      { answerOption: "Hyper Text Marker Language", isCorrect: false },
      { answerOption: "Hyper Text Maker Language", isCorrect: false },
      { answerOption: "Hyper Text Marking Language", isCorrect: false },
    ],
  },
  {
    question: "What is used to style the HTML pages?",
    options: [
      { answerOption: "C++", isCorrect: false },
      { answerOption: "C#", isCorrect: false },
      { answerOption: "CSV", isCorrect: false },
      { answerOption: "CSS", isCorrect: true },
    ],
  },
  {
    question: "What is used to add interactivity to the HTML pages?",
    options: [
      { answerOption: "API", isCorrect: false },
      { answerOption: "JavaScript", isCorrect: true },
      { answerOption: "Java", isCorrect: false },
      { answerOption: "XML", isCorrect: false },
    ],
  },
  {
    question: "What is the proper sequence of states of link in HTML?",
    options: [
      { answerOption: "link,visited,hover,active", isCorrect: true },
      { answerOption: "hover,active,visited,link", isCorrect: false },
      { answerOption: "visited,link,active,hover", isCorrect: false },
      { answerOption: "active,visited,link,hover", isCorrect: false },
    ],
  },
  {
    question: "What is used to style the HTML pages?",
    options: [
      { answerOption: "C++", isCorrect: false },
      { answerOption: "C#", isCorrect: false },
      { answerOption: "CSV", isCorrect: false },
      { answerOption: "CSS", isCorrect: true },
    ],
  },
];

// CSS Questions

export const CssQuestions = [
  {
    question: "What does CSS stand for?",
    options: [
      { answerOption: "Cascading Style Sheets", isCorrect: true },
      { answerOption: "Creative Style Sheets", isCorrect: false },
      { answerOption: "Colorful Style Sheets", isCorrect: false },
      { answerOption: "Computer Style Sheets", isCorrect: false },
    ],
  },
  {
    question:
      "Which of the following selector matches a element based on its id?",
    options: [
      { answerOption: "The Id selector", isCorrect: true },
      { answerOption: "The Universal selector", isCorrect: false },
      { answerOption: "The Descendent selector", isCorrect: false },
      { answerOption: "The Class Selector", isCorrect: false },
    ],
  },
  {
    question:
      "Where in an HTML document is the correct place to refer to an external style sheet?",
    options: [
      { answerOption: "in the <head> section", isCorrect: true },
      { answerOption: "In the <body> section", isCorrect: false },
      { answerOption: "In the <title> section", isCorrect: false },
      { answerOption: "At the end of the document", isCorrect: false },
    ],
  },
  {
    question: "Which HTML attribute is used to define inline styles?",
    options: [
      { answerOption: "class", isCorrect: false },
      { answerOption: "styles", isCorrect: false },
      { answerOption: "style", isCorrect: true },
      { answerOption: "font", isCorrect: false },
    ],
  },
  {
    question: "Which is the correct CSS syntax?",
    options: [
      { answerOption: "{body;color:black;}", isCorrect: false },
      { answerOption: "body:color=black;", isCorrect: false },
      { answerOption: "{body:color=black;}", isCorrect: false },
      { answerOption: "body{color: black;}", isCorrect: true },
    ],
  },
];

// JavaScript Questions

export const JavaScriptQuestions = [
  {
    question: "Inside which HTML element do we put the JavaScript?",
    options: [
      { answerOption: "<script>", isCorrect: true },
      { answerOption: "<js>", isCorrect: false },
      { answerOption: "<scripting>", isCorrect: false },
      { answerOption: "<javascript>", isCorrect: false },
    ],
  },
  {
    question:
      "Which of the following function of Array object adds and/or removes elements from an array?",
    options: [
      { answerOption: "toSource()", isCorrect: false },
      { answerOption: "sort()", isCorrect: false },
      { answerOption: "splice()", isCorrect: true },
      { answerOption: "unshift()", isCorrect: false },
    ],
  },
  {
    question: "How do you call a function named &#34;myFunction&#34;?",
    options: [
      { answerOption: "call myFunction()", isCorrect: false },
      { answerOption: "call function myFunction()", isCorrect: false },
      { answerOption: "myFunction()", isCorrect: true },
      { answerOption: "call myFunction() function", isCorrect: false },
    ],
  },
  {
    question: "How do you round the number 7.25, to the nearest integer?",
    options: [
      { answerOption: "rnd(7.25)", isCorrect: false },
      { answerOption: "Math.rnd(7.25)", isCorrect: false },
      { answerOption: "Math.round(7.25)", isCorrect: true },
      { answerOption: "round(7.25)", isCorrect: false },
    ],
  },
  {
    question:
      "Which built-in method reverses the order of the elements of an array?",
    options: [
      { answerOption: "changeOrder(order)", isCorrect: false },
      { answerOption: "reverse()", isCorrect: true },
      { answerOption: "sort(order)", isCorrect: false },
      { answerOption: "None of the Above", isCorrect: false },
    ],
  },
];
